import React, { useState } from "react";
import styles from "./ForgotPassword.module.css";
import Logo from "../../components/Logo";
import SideBackground from "../../components/SideBackground";
import { useAuthApi } from "../../hooks/useAuthApi";
import useNotification from "../../hooks/useNotification";
import NotificationSnackbar from "../../components/NotificationSnackbar";
import { Button, TextField } from "@mui/material";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { requestForgotPassword, loading, error, clearError } = useAuthApi();
  const { notification, showNotification, hideNotification } =
    useNotification();

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();

    const result = await requestForgotPassword(email);

    if (result) {
      setIsSubmitted(true);
      showNotification("Password reset email sent successfully!");
    } else if (error) {
      showNotification(error, "error");
    }
  };

  return (
    <div className={styles.forgotRoot}>
      <div className={styles.forgotLeft}>
        <Logo />
        <div className={styles.forgotForm}>
          <h2>Forgotten Password</h2>
          <div
            style={{
              fontSize: "13px",
              width: "100%",
              textAlign: "center",
              marginBottom: 12,
              color: "#666",
            }}
          >
            <p>
              Enter the email registered against your account.
              <br />
              If a valid email is entered, a reset password email will be sent.
              <br />
              Please follow the instructions found within the email
            </p>
          </div>
          <form
            onSubmit={handleSubmit}
            style={{
              width: "100%",
              maxWidth: "260px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <TextField
              id="forgot-email"
              type="email"
              label={"Email"}
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              disabled={loading}
              inputProps={{ maxLength: 255 }}
              sx={{
                width: "100%",
                maxWidth: 260,
                marginBottom: 1,
                "& .MuiInputBase-input": {
                  fontSize: 14,
                  height: 44,
                  boxSizing: "border-box",
                  padding: "10px 14px",
                },
                "& input:-webkit-autofill": {
                  fontSize: 14,
                  height: 44,
                  boxSizing: "border-box",
                  padding: "10px 14px",
                  WebkitBoxShadow: "0 0 0 100px #fff inset",
                  WebkitTextFillColor: "#000",
                },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={loading}
              sx={{
                maxWidth: 260,
                width: "100%",
                backgroundColor: "#AB2C29",
                "&:hover": { backgroundColor: "#b71c1c" },
              }}
            >
              {loading ? "Sending..." : "Reset Password"}
            </Button>
          </form>
        </div>
      </div>
      <SideBackground>
        <div className={styles.forgotBgOverlay}></div>
      </SideBackground>
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
      />
    </div>
  );
}
